import React, { useState } from 'react';
import { useFloating, offset, flip, shift } from '@floating-ui/react-dom';
import { useClickOutside, useDisclosure } from '@mantine/hooks';
import { StyledSubscriptionTooltip } from './SubscriptionTooltip.styled';

export const SubscriptionTooltip: React.FC<SubscriptionTooltipData> = ({
  children,
}) => {
  const [isOpen, handlers] = useDisclosure(false);

  const ref = useClickOutside<HTMLDivElement>(handleClickOutside);

  function handleClickOutside() {
    if (isOpen) {
      handlers.close();
    }
  }

  const { x, y, reference, floating, strategy } = useFloating({
    placement: 'bottom-start',
    middleware: [offset(-60), flip(), shift()],
  });

  return (
    <StyledSubscriptionTooltip ref={ref}>
      <button
        type="button"
        ref={reference}
        aria-describedby="subscription-tooltip"
        onClick={() => handlers.toggle()}
      >
        ?
      </button>
      {isOpen && (
        <div
          ref={floating}
          style={{
            position: strategy,
            top: y ?? 0,
            left: x ?? 0,
          }}
          className="tooltip"
          role="subscription-tooltip"
        >
          {children}
          <a className="close" onClick={() => handlers.close()}>
            &times;
          </a>
        </div>
      )}
    </StyledSubscriptionTooltip>
  );
};

export interface SubscriptionTooltipData {
  children: any;
}
